export default "__VITE_ASSET__CwrVUoh6__"